enum Locales {
  Australia = 'en-AU',
}

export default Locales;
